import { enableFade } from 'core/handlers/FadeHandler'
import { FormatService } from 'services/FormatService'
import { makeHistoryRequest } from 'services/ServerService'
import { signal } from 'services/SignalsService'

export default class HistoryEntity extends PIXI.Container {
  constructor() {
    super()
    this.fadeSelf = enableFade(this)
    this.format = FormatService.currency
    this.user = game.models.UserModel.get()
    this.cells = []
    this.records = []
    this.page = 0
    this.spinner

    signal.on('RADIO:menu', this.fade.bind(this))
    signal.on('STATE:IN:BET', this.reset.bind(this))
    signal.on('RADIO:menu|history', this.makeMove(Number.MIN_VALUE))
    signal.on('BUTTON:history|prev', this.makeMove(-1))
    signal.on('BUTTON:history|next', this.makeMove(1))
  }

  fade(value) {
    this.fadeSelf( value == 'history')
  }

  reset() {
    this.page = 1
    this.records = []
  }

  update(offset) {
    this.cells.forEach(({ text, row, col }) => text.update(this.records[offset * 11 + row][col]))
  }

  parse({ transactions }) {
    this.records = transactions.map(({ time, roundId, bet, win }) => [time, roundId, this.format(bet), this.format(win)])
  }

  makeMove(diff) {
    return async function () {
      this.page = Math.max(this.page + diff, 1)
      signal.dispatch('HISTORY:PAGE', this.page) //todo finish with bounds?
      if (this.records.length < this.page * 11) {
        this.spinner.visible = true
        this.parse(await makeHistoryRequest({ ...this.user, count: this.page * 11 }))
      }
      this.spinner.visible = false
      this.update(this.page - 1)
    }
  }

  register = (type, object) => {
    if (type == 'HistoryText') {
      const [row, col] = object.name.split('-').map(parseFloat)
      this.cells.push({ text: object, row, col })
    }
    if (type == 'AnimationSpine') {
      this.spinner = object
      signal.on('RESIZE', () => this.spinner.visible = false)
    }
  }
}
